import { render, staticRenderFns } from "./DSquare.vue?vue&type=template&id=4f601444&scoped=true"
import script from "./DSquare.vue?vue&type=script&lang=js"
export * from "./DSquare.vue?vue&type=script&lang=js"
import style0 from "./DSquare.vue?vue&type=style&index=0&id=4f601444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f601444",
  null
  
)

export default component.exports